export const SIGNAL_R_HOST_CHUNK = '/signalr/';
